import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { apiError, authorization } from 'Utils/alerts'

const { REACT_APP_URL } = process.env

const BaseService = axios.create({
    baseURL: `${REACT_APP_URL}/api`,
    timeout: 60000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
    },
})

export function useAxiosLoader() {
    const [count, setCount] = useState(0)

    const interceptors = useMemo(() => {
        const inc = () => setCount(c => c + 1)
        const dec = () => setCount(c => c - 1)
        return {
            request: req => {
                inc()
                authorization(req)
                return req
            },
            response: res => {
                dec()
                return res
            },
            error: err => {
                dec()
                apiError(err)
                return Promise.reject(err)
            },
        }
    }, [])

    useEffect(() => {
        const reqInterceptor = BaseService.interceptors.request.use(interceptors.request, interceptors.error)
        const resInterceptor = BaseService.interceptors.response.use(interceptors.response, interceptors.error)
        return () => {
            BaseService.interceptors.request.eject(reqInterceptor)
            BaseService.interceptors.response.eject(resInterceptor)
        }
    }, [interceptors])

    return count > 0
}

export default BaseService
